/*
権限判定のユーティリティ
*/

import { PfmPermission } from "../models/PfmUser";

export const isAuthorized = (perm_id: string, permissions: PfmPermission[]) => {
  if (permissions.filter((d) => d.perm_id === perm_id).length > 0) {
    return true;
  }

  return false;
};
